export const API_URL = "/api";

export const api = {
  USERDETAILS_URL: `${API_URL}/user-details`,
  LOGIN_URL: `${API_URL}/login`,
  LOGOUT_URL: `${API_URL}/logout`,
  HOSPITALS_URL: `${API_URL}/hospitals`,
  USERS_URL: `${API_URL}/rode/users`,
  HOSPITALINFO_URL: `${API_URL}/hospitals/info`,
  HOSPITALSURVEY_URL: `${API_URL}/hospitals/survey`,
  SURVEYQUESTIONS_URL: `${API_URL}/hospitals/survey/questions`,
  OFFEREDANSWERS_URL: `${API_URL}/hospitals/survey/offered-answers`,
  POSTSURVEY_URL: `${API_URL}/hospitals/survey/save`,
  CONFIRMSURVEY_URL: `${API_URL}/hospitals/survey/confirm`,
  REVIEWCOMMENT_URL: `${API_URL}/hospitals/survey/review-comment`,
  HOSPITALPICTURES_URL: `${API_URL}/hospitals/pictures`,
  ADDPICTURE_URL: `${API_URL}/hospitals/pictures/save`,
  REVIEWREQUESTS_URL: `${API_URL}/requests`,
  STATISTICSFIELDS_URL: `${API_URL}/rode/hospitals/statistics/fields`,
  BIRTHPLAN_URL: `${API_URL}/public-api/plan`,
  SERVICES_URL: `${API_URL}/hospitals/services`,
  OPTIONALQUESTIONS_URL: `${API_URL}/hospitals/survey/optional-questions`,
};

export const routes = {
  RODILISTA_RODA_HR: "https://rodilista.roda.hr/",
  DATA_ENTRY_URL: "/unos-podataka",
  LOGIN_URL: "/prijava",
  PASSWORD_SETUP_URL: "/postavljanje-lozinke",
  EXPIRED_TOKEN_URL: "/neuspjesni-reset",
  PARSE_TOKEN_URL: "/validacija-zahtjeva",
  PASSWORD_RESET_URL: "/reset-lozinke",
  PASSWORD_UPDATED_URL: "/promijenjena-lozinka",
  NURSE_HOMEPAGE_URL: "/rodiliste-pocetna",
  RODA_HOMEPAGE_URL: "/roda-pocetna",
  RODA_USER_ADMINISTRATION_URL: "/administracija-korisnika",
  RODA_REQUESTS_URL: "/zahtjevi",
  PUBLIC_STATISTICS_URL: "/pregled-statistike",
  BIRTH_PLAN_URL: "/plan-poroda",
  BIRTH_PLAN_FORM: "/moj-plan-poroda",
  BIRTH_PLAN_PDF: "/test-pdf",
  ACCESS_DENIED_URL: "/greska",
};
